import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  noOrdererPhoneError: {
    id: 'sendSmsDialog.noOrdererPhoneError',
    defaultMessage: 'Tilaajalle ei ole määritelty puhelinnumeroa.',
  },
  sendSuccessTitle: {
    id: 'sendSmsDialog.sendSuccessTitle',
    defaultMessage: 'Lähetys onnistui',
  },
  sendSuccessMessage: {
    id: 'sendSmsDialog.sendSuccessMessage',
    defaultMessage: 'Viesti lähetetty onnistuneesti',
  },
  header: {
    id: 'sendSmsDialog.header',
    defaultMessage: 'Lähetä SMS viesti',
  },
  phoneLabel: {
    id: 'sendSmsDialog.phoneLabel',
    defaultMessage: 'Puhelinnumero',
  },
  ordererLabel: {
    id: 'sendSmsDialog.ordererLabel',
    defaultMessage: 'Tilaaja',
  },
  messageLabel: {
    id: 'sendSmsDialog.messageLabel',
    defaultMessage: 'Viesti',
  },
  sendLabel: {
    id: 'sendSmsDialog.sendLabel',
    defaultMessage: 'Lähetä',
  },
  cancelLabel: {
    id: 'sendSmsDialog.cancelLabel',
    defaultMessage: 'Peruuta',
  },
})
